export default {
  "header": {
    "title": "Listas de checklist digitales"
  },
  "card": {
    "list": {
      "title": "Listas",
      "create": "Crear listas",
      "name": "Nombre",
      "click": "Haz click para agregar ítem",
      "delete": "Eliminar",
      "action": "Acciones",
      "label_alert": "El nombre de la lista debe tener al menos una letra",
      "legend_text": "No hay listas creadas",
      "placeholder": "Agregar una lista ...",
      "label": "Añade otra lista presionando Enter o cancelar presionando Esc"
    },
    "item": {
      "title": "Items de lista",
      "tooltip_err_mes": "Debes seleccionar una lista para agregar un ítem",
      "create": "Agregar ítem",
      "delete": "Eliminar",
      "edit": "Editar",
      "new_items": "-nuevos ítems creados",
      "edited_items": "-ítems editados",
      "delete_items": "-ítems eliminados",
      "name": "Nombre",
      "action": "Acciones",
      "legend_text": "No hay ítems creados",
      "label": "Añade otro ítem presionando Enter o cancelar presionando Esc.",
      "label_alert": "El nombre del ítem debe tener al menos una letra o un número",
      "placeholder": "Agregar un ítem a la lista",
      "btn_cancel": "Cancelar",
      "btn_save": "Guardar"
    },
    "input": {
      "addItemLabel": "agregar ítem",
      "labelAlert": "El nombre de la lista debe tener al menos una letra o un número"
    },
    "toastrLable": {
      "success": "Lista creada con éxito",
      "info": "Información",
      "error": "Lista no ha creado",
      "deletError": "La lista no fue eliminada",
      "itemDeleteSuccess": "Item eliminado con éxito",
      "listDeleteSuccess": "Lista eliminada con éxito",
      "itemEditSuccess": "Item ha sido editado con éxito",
      "confirm": "Si",
      "cancel": "No",
      "question": "Estas seguro que quieres eliminar",
      "list": "la lista",
      "item": "el ítem",
      "err": "Error",
      "caution": "Eliminar una lista que está siendo utilizada por un checklist digital",
      "caution1": "podría generar comportamientos inesperados.",
      "deleteItem": "Eliminar el ítem",
      "editItem": "Editar ítem",
      "change": "Información guardada con éxito",
      "notChange": "Los cambios no fueron guardados",
      "save": "Estas seguro que quieres guardar los siguientes cambios en la lista",
      "_cancel": "Estas seguro que quieres cancelar los cambios realizados en la lista"
    }
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/spanish/dynamic_list.js